// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Native Vue stuff
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Stuff to #use
import axios from './api/vue-axios/axios'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'
import VueAnalytics from 'vue-analytics'
import { ClientTable } from 'vue-tables-2'
import VueSlider from 'vue-slider-component'
// import VueIntercom from 'vue-intercom'
import VueMeta from 'vue-meta'

// Mixins
import dateMixin from './mixins/date'
import utilityMixin from './mixins/utility'

// CSS
import 'font-awesome/css/font-awesome.css'
import '@/assets/styles/shared.css'
import '@/assets/styles/vue-slider.css'


// IMPT we have to set the token in our header every single time
axios.interceptors.request.use(request => {
  // Get token from localStorage
  const token = localStorage.token
  // Update token axios header
  if (token) {
    request.headers['Authorization'] = 'Bearer ' + token
  }
  return request
})

// TODO this should be cleaned up, and moved out of this file.
// Add simple global error handling. This is the default and can be overridden during individual API calls.
axios.interceptors.response.use(response => {
  // all is well, clear any lingering errors
  store.dispatch('removeError')
  return response
}, error => { // display error message
  // Handle network error first
  if (!error.response) {
    store.dispatch('addError', { errorMessage: 'There was a problem connecting to our servers. Please login and try again.', hideDefault: true })
    return
  }
  /// 404 will be handled in router
  if (error.response.status === 404) return Promise.reject(error)

  // We want to first handle errors for expired tokens
  if (error.response.data && error.response.data.error === 'INVALID_TOKEN') {
    store.dispatch('addError', { errorMessage: 'Your session has expired. Please log in again', hideDefault: true })
    return Promise.reject(error)
  }
  // Then we want to bypass showing error message for incorrect login
  if (error.response.status === 401) return Promise.reject(error)
  // otherwise just show the error!
  let errorMessage = ''
  if (error.response.data && error.response.data.error) errorMessage = error.response.data.error
  else if (error.response && error.response.statusText) errorMessage = error.response.statusText
  else errorMessage = error.message

  store.dispatch('addError', { errorMessage: errorMessage })
  return Promise.reject(error)
})

// Use stuff
Vue.use(VueAxios, axios)
Vue.use(VueClipboard)
Vue.use(ClientTable)
// Vue.use(VueIntercom, { appId: 'mcbeomku' })
Vue.use(VueAnalytics, {
  id: 'UA-139852130-1',
  router,
  checkDuplicatedScript: true,
  debug: {
    enabled: !process.env.NODE_ENV === 'production',
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})
Vue.component('VueSlider', VueSlider)

// Add global mixins
Vue.mixin(dateMixin)
Vue.mixin(utilityMixin)

Vue.config.productionTip = false


// Could go elsewhere...
Vue.directive('showOnScroll', {
  inserted: function (el, binding) {
    el.style['visibility'] = 'hidden'

    let f = function (evt) {
      if (window.scrollY > binding.value) el.style['visibility'] = 'visible'
      else el.style['visibility'] = 'hidden'
    }
    window.addEventListener('scroll', f)
  }
})

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js